"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponQRcode = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var CouponQRcode = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CouponQRcode, _super);
    function CouponQRcode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '优惠券二维码';
        _this.code = '300202';
        _this.desc = '优惠券二维码';
        _this.requestParams = new coupon_1.CouponQRcodeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CouponQRcode;
}(service_1.BaseService));
exports.CouponQRcode = CouponQRcode;
//# sourceMappingURL=couponQRcode.js.map